<template>
	<div class="order-form-carousel">
		<BCarousel
			:interval="5000"
			:controls="renderControls"
			:indicators="renderControls"
		>
			<BCarouselSlide
				v-for="(item, index) in collectImages"
				:key="`${item}-${index}}`"
				:img-src="item"
			></BCarouselSlide>
		</BCarousel>

		<p v-if="description" class="order-form-carousel__description">
			{{ description }}
		</p>
	</div>
</template>

<script>
import { BCarousel, BCarouselSlide } from 'bootstrap-vue';

export default {
	components: {
		BCarousel,
		BCarouselSlide,
	},
	props: {
		items: {
			type: Array,
			required: true,
		},
		description: {
			type: String,
			default: '',
		},
	},
	computed: {
		renderControls() {
			return this.items.length > 1;
		},
		collectImages() {
			return this.items.slice(0, 5);
		},
	},
};
</script>

<style lang="scss">
.order-form-carousel {
	display: grid;
	gap: var(--size-lg);
	max-width: 360px;
	margin: 0 auto;

	@media screen and (max-width: 992px) {
		margin-top: var(--size-lg);
	}

	.carousel-indicators {
		bottom: -36px;
	}

	.carousel-item {
		border-radius: var(--size-xs);
		overflow: hidden;
	}

	.carousel-indicators li {
		background-color: var(--gray-400);

		&.active {
			background-color: var(--gray-800);
		}
	}

	&__description {
		text-align: center;
		font-size: var(--size-sm);
		color: var(--gray-600);
	}
}
</style>
